// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1oIJm","colLarge":"styles_colLarge__2Aidh","col":"styles_col__2ipMn","colCheckbox":"styles_colCheckbox__2rQ9L","actions":"styles_actions__2aNrZ"};